import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/home.vue'
import Specimen from '@/pages/users/specimen.vue'
import Plant from '../pages/users/plant.vue'
import Detail from '../pages/detail.vue'
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/users/Specimen',
        name: 'Specimen',
        component: Specimen
    },
    {
        path: '/users/plant',
        name: 'Plant',
        component: Plant
    },
    {
        path: '/detail',
        name: 'Detail',
        component: Detail
    },

]
const router = createRouter({
    history: createWebHistory(),
    routes

})
export default router
